import HTTPClient from './http-client-public';

const END_POINT = '/public';

const submitAccessRequestInfohidro = async (object) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const headers = { headers: {'Content-Type': 'application/json'} };

  return api.post(`${END_POINT}/infohidro/email-send/access_request`, object, headers);
}

export {
  submitAccessRequestInfohidro,
}
